var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('router-view'),_c('modal-container'),_c('snackbar-container')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }